module.exports = __webpack_public_path__ + "img/trap-red.f01dd79e.png";